import React from "react";
import { Box, Typography } from "@mui/material";

const ErrorScreen = ({ message }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        // bgcolor: "rgba(255, 0, 0, 0.1)",
        zIndex: 1000,
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          padding: {xs:3,sm:4, md:5,lg:6},
          backgroundColor: "#fff",
          borderRadius: 3,
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
          maxWidth: "500px",
        }}
      >
        <Typography sx={{fontSize:{xs:"20px",sm:"24px", md:"26px",lg:"28px"}}} color="error" >
          {message}
        </Typography>
      </Box>
    </Box>
  );
};

export default ErrorScreen;
